import { useContext } from "react";

import { DataContext } from "../../context/DataContext";

const ItineraryCardLogic = () => {
  const {
    facilitiesData,
  } = useContext(DataContext);

  const getBookedDetails = (
    facilityId,
    Type,
    treatsLocation,
    actStrapiId
  ) => {
    let bookedFacilityDetails;

    if (Type === "Spa") {
      bookedFacilityDetails = facilitiesData.find(
        (row) => row.id === facilityId && row.objType === Type
      );
    } else {
      bookedFacilityDetails = facilitiesData.find(
        (row) => row.id === facilityId
      );
    }
    
    if (Type === "Venue") {
      // Entertainment/Venue type removed - use facility title
      bookedFacilityDetails.entTitle = bookedFacilityDetails?.title || "Venue";
    }

    return JSON.parse(JSON.stringify(bookedFacilityDetails));
  };

  const getSummaryValue = (data, key) => {
    let counts = {};
    data.summary[key].forEach((x) => {
      counts[x] = (counts[x] || 0) + 1;
    });
    const preparedString = [];
    Object.entries(counts).forEach(([key, value]) => {
      if (value === 1) {
        preparedString.push(key);
      } else {
        preparedString.push(`${value} x ${key}`);
      }
    });
    return preparedString.join(", ");
  };

  return {
    getBookedDetails,
    getSummaryValue,
  };
};

export default ItineraryCardLogic;
